import { useEffect, useState } from "react";
import { api, API } from "@/lib/api";
import { PageTitle, GBtn } from "./ui";
import { Download } from "lucide-react";

export default function Subscribers() {
  const [subs, setSubs] = useState([]);
  useEffect(() => { api.get("/admin/subscribers").then((r) => setSubs(r.data)); }, []);
  return (
    <>
      <PageTitle title="Subscribers" subtitle={`${subs.length} people`}
        right={<a href={`${API}/admin/subscribers-export`} data-testid="subs-export"><GBtn variant="ghost"><Download size={16} /> Export CSV</GBtn></a>} />
      <div className="card-surface rounded-2xl overflow-x-auto">
        <table className="w-full text-sm min-w-[560px]">
          <thead><tr className="border-b border-white/10 text-white/50 text-xs uppercase">
            <th className="text-left p-4">Name</th><th className="text-left p-4">Email</th><th className="text-left p-4">Consent</th><th className="text-left p-4">Last resource</th><th className="text-left p-4">Joined</th>
          </tr></thead>
          <tbody>
            {subs.map((s) => (
              <tr key={s.id} className="border-b border-white/5 hover:bg-white/5">
                <td className="p-4">{s.name}</td><td className="p-4">{s.email}</td>
                <td className="p-4">{s.consent ? "Yes" : "No"}</td>
                <td className="p-4 text-white/50">{s.last_resource}</td>
                <td className="p-4 text-white/40 text-xs">{s.created_at ? new Date(s.created_at).toLocaleDateString("en-GB") : ""}</td>
              </tr>
            ))}
            {subs.length === 0 && <tr><td colSpan={5} className="p-10 text-center text-white/30">No subscribers yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </>
  );
}
